/** Animated pink dot-grid overlay — sits over the full-page dark background. */
export const DotGrid = () => (
  <>
    <style>{`
      @keyframes dotPulse {
        0%, 100% { opacity: 1; }
        50%       { opacity: 0.35; }
      }
    `}</style>
    <div
      className="absolute top-0 left-0 w-full pointer-events-none"
      style={{
        height: "50%",
        backgroundImage:
          "radial-gradient(circle, color-mix(in srgb, var(--brand-pink) 35%, transparent) 1.5px, transparent 1.5px)",
        backgroundSize: "22px 22px",
        maskImage: "linear-gradient(to bottom, black 40%, transparent 100%)",
        WebkitMaskImage: "linear-gradient(to bottom, black 40%, transparent 100%)",
        animation: "dotPulse 4s ease-in-out infinite",
        zIndex: 0,
      }}
    />
  </>
);
